module.exports = __webpack_public_path__ + "static/media/logoHeader.35d22bc8.png";